import { render, staticRenderFns } from "./CampaignsEdit.vue?vue&type=template&id=18eff3fc&scoped=true&"
import script from "./CampaignsEdit.vue?vue&type=script&lang=js&"
export * from "./CampaignsEdit.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsEdit.vue?vue&type=style&index=0&id=18eff3fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18eff3fc",
  null
  
)

export default component.exports